import { useState } from "react";
import Hero from "./components/Hero";
import FeaturedWorks from "./components/FeaturedWorks";
import GenreGrid from "./components/GenreGrid";
import LatestUpdates from "./components/LatestUpdates";
import ResourcePreview from "./components/ResourcePreview";
import ArticlePreview from "./components/ArticlePreview";
import FaqPreview from "./components/FaqPreview";

function CollectCta() {
  const [saved, setSaved] = useState(false);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="rounded-2xl border border-background-200/70 bg-gradient-to-br from-background-100 via-background-100 to-background-200/70 p-8 md:p-12 text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold comic-pop">
          한 번에 모두 보기
        </span>
        <h2 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">
          收藏这一页，韩漫资源全都有
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
          资源站、韩漫APP、新作连载、阅读指南……我们把韩国免费漫画的资源渠道都整理在了一个页面里，收藏即用，随时打开就能追更。
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => setSaved((v) => !v)}
            className={`w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm whitespace-nowrap transition-colors font-bold ${
              saved
                ? "bg-accent-500 text-background-50"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className={`${saved ? "ri-bookmark-fill" : "ri-bookmark-line"}`}></i>
            {saved ? "已收藏本页" : "收藏本页"}
          </button>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Hero />
      <FeaturedWorks />
      <GenreGrid />
      <LatestUpdates />
      <ResourcePreview />
      <ArticlePreview />
      <FaqPreview />
      <CollectCta />
    </>
  );
}